export function LandingBackground() {
  return (
    <div
      className="absolute top-0 inset-0 -z-10"
      style={{
        backgroundImage: "url('/img/hero-landing-page.jpg')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top center",
      }}
    >
      {/* Soften the light hero photo in dark mode so pricing/marketing pages
          stay readable against the same asset used in light mode. */}
      <div className="pointer-events-none absolute inset-0 hidden bg-zinc-950/75 dark:block" />
      {/* Page background */}
      {/* <div
				className="absolute inset-0"
				style={{ backgroundColor: "#FBFBFB" }}
			/>
			<div
				className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-[min(385px,30vw)] h-[819px] w-[min(779px,90vw)] max-w-[779px]"
				style={{
					background:
						"linear-gradient(89.73deg, rgba(219, 230, 252, 0.6) 15.83%, rgba(227, 242, 255, 0.6) 51.98%, rgba(225, 233, 255, 0.6) 84.19%)",
					mixBlendMode: "plus-darker",
					filter: "blur(37px)",
				}}
			/>
			<div
				className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-[min(297px,25vw)] h-[min(731px,60vw)] w-[min(1299px,95vw)] max-w-[1299px] overflow-hidden rounded-[365.5px] border-b-20 border-[#D2DDF8] opacity-20"
				style={{
					backgroundImage: "url('/img/landingpage-supernova.png')",
					backgroundSize: "cover",
					backgroundPosition: "center",
					boxShadow: "13px 116px 180px 32px #A7C1FF",
				}}
			/> */}
    </div>
  );
}
